var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBowls({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.43 5.745a.386.386 0 0 0 .298-.543 4.84 4.84 0 0 1 .26-.367 4.669 4.669 0 0 1 4.818 7.377 4.662 4.662 0 0 1-1.4.138A3.908 3.908 0 0 0 .283 6.101c.045-.121.094-.24.148-.356zm.822-1.218a4.653 4.653 0 1 1 4.943 7.568 4.916 4.916 0 0 0-4.943-7.568zM4.1 12.324A4.654 4.654 0 0 1 .187 6.393 3.661 3.661 0 0 1 4.1 12.324zm-1.204-1.769c-.442.276-1.148-.058-1.578-.745-.43-.688-.42-1.47.022-1.746.441-.275 1.148.058 1.577.746.43.688.42 1.47-.021 1.745z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 2.764,
    cy: 2.764,
    r: 2.764
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DF0411",
    d: "M14.418 3.538l-.018.04a.358.358 0 0 0 .272.475c.053.129.1.26.14.393a4.333 4.333 0 0 1-8.173-.264 4.327 4.327 0 0 1 .642-1.139 3.627 3.627 0 0 0 6.944.192c.069.099.133.2.193.303zm.488 1.272a4.318 4.318 0 1 1-8.384-.271 4.562 4.562 0 0 0 8.297.446l.087-.175zM7.464 2.825a4.319 4.319 0 0 1 6.59.182A3.398 3.398 0 0 1 7.5 2.974l-.035-.15zm1.985.026c.025-.483.655-.842 1.406-.803.752.04 1.34.463 1.316.946-.026.482-.655.841-1.407.802-.752-.04-1.34-.463-1.315-.945z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#EDEEEE",
    transform: "translate(7.681 8.66)",
    xlinkHref: "#b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowls);
export default __webpack_public_path__ + "static/media/bowls.017dcc768875f6415823c79ea773602a.svg";
export { ForwardRef as ReactComponent };